import { combineReducers } from 'redux';

import externalAll from './externalAll';
import externalOnlyMine from './externalOnlyMine';
import internal from './internal';

/**
 * @typedef {{
 *   internal: import('./internal').CountByTypeInternalReducer,
 *   externalAll: import('./externalAll').CountByTypeAllExternalReducer,
 *   externalOnlyMine: import('./externalOnlyMine').CountByTypeOnlyMineExternalReducer,
 * }} ChatUiCountByTypeReducer
 */

export default combineReducers({
  internal,
  externalAll,
  externalOnlyMine,
});
